import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private dataSource: BehaviorSubject<any>;
  public data$: Observable<any>;

  constructor() {
    this.dataSource = new BehaviorSubject<Map<string, any>>(new Map());
    this.data$ = this.dataSource.asObservable();
  }

  updateData(key: string, value: any): void {
    const updatedMap = new Map(this.dataSource.value);
    updatedMap.set(key, value);
    this.dataSource.next(updatedMap);
  }

  clearData(): void {
    this.dataSource.next(new Map());
  }

  getData(key: string): any {
    return this.dataSource.value.get(key);
  }

  getAssessmentYear() {
    return localStorage.getItem('CURRENT_ASSESSMENT_YEAR');
  }

  getIncomeYear() {
    const assessmentYear = this.getAssessmentYear();
    if (!assessmentYear) return '';

    const [startYear, endYear] = assessmentYear.split('-').map(Number);
    return `${startYear - 1}-${endYear - 1}`;
  }

  getAssessmentYearDates(): string[] {
    const assessmentYear = this.getAssessmentYear();
    let assessmentStart = '';
    let assessmentEnd = '';
    if (assessmentYear) {
        assessmentStart = `${assessmentYear.split('-')[0]}-07-01`;
        assessmentEnd = `${assessmentYear.split('-')[1]}-06-30`;
    }
    return [assessmentStart, assessmentEnd];
  }

  getIncomeYearDates(): string[] {
    const incomeYear = this.getIncomeYear();
    let incomeStart = '';
    let incomeEnd = '';
    if (incomeYear) {
        incomeStart = `${incomeYear.split('-')[0]}-07-01`;
        incomeEnd = `${incomeYear.split('-')[1]}-06-30`;
    }
    return [incomeStart, incomeEnd];
  }
}
